<template>
  <div>
    <h1>Show {{ item && item['@id'] }}</h1>

    <div v-if="loading" class="alert alert-info" role="status">Loading...</div>
    <div v-if="error" class="alert alert-danger" role="alert"><span class="oi oi-warning" aria-hidden="true"></span> {{ error }}</div>
    <div v-if="deleteError" class="alert alert-danger" role="alert"><span class="oi oi-warning" aria-hidden="true"></span> {{ deleteError }}</div>

    <div v-if="item" class="table-responsive">
      <table class="table table-striped table-hover">
        <tbody>
          <tr>
            <td>Email</td>
            <td>{{ item['email'] }}</td>
          </tr>
          <tr>
            <td>Full Name</td>
            <td>{{ item['fullname'] }}</td>
          </tr>
          <tr>
            <td>Username</td>
            <td>{{ item['username'] }}</td>
          </tr>
          <tr>
            <td>Enabled</td>
            <td>{{ item['enabled'] }}</td>
          </tr>
          <tr>
            <td>Roles</td>
            <td>{{ item['roles'] }}</td>
          </tr>
          <tr>
            <td>Last Login</td>
            <td>{{ item['lastLogin'] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <footer class="footer fixed-bottom bn-footer">
      <div style="float:right">
        <router-link v-if="item" :to="{ name: 'UserList' }" class="btn btn-primary btn-sm">Back to list</router-link>
        <button @click="deleteItem(item)" class="btn btn-danger btn-sm">Delete</button>
      </div>
    </footer>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    computed: mapGetters({
      deleteError: 'user/del/error',
      error: 'user/show/error',
      loading: 'user/show/loading',
      item: 'user/show/item',
    }),
    methods: {
      deleteItem (item) {
        if (window.confirm('Are you sure you want to delete this item?'))
          this.$store.dispatch('user/del/delete', item).then(response => this.$router.push({ name: 'UserList' }));
      }
    },
    created () {
      this.$store.dispatch('user/show/retrieve', decodeURIComponent(this.$route.params.id));
    },
    beforeDestroy() {
      this.$store.dispatch('user/show/reset');
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/Show.vue